import { api } from "@/api/client";
import type { UserDetail, UserSummary } from "@/types/api";

export interface UserCreateRequest {
  username: string;
  password: string;
  is_admin?: boolean;
  permissions?: string[];
}

export interface UserUpdateRequest {
  password?: string;
  is_admin?: boolean;
  is_active?: boolean;
  permissions?: string[];
  one_c_user_ref?: string | null;
  one_c_user_name?: string | null;
}

export interface OneCUser {
  ref: string;
  name: string;
}

export async function listOneCUsers(): Promise<OneCUser[]> {
  const { data } = await api.get<OneCUser[]>("/admin/one-c-users");
  return data;
}

export async function listUsers(): Promise<UserSummary[]> {
  const { data } = await api.get<UserSummary[]>("/admin/users");
  return data;
}

export async function getUser(id: number): Promise<UserDetail> {
  const { data } = await api.get<UserDetail>(`/admin/users/${id}`);
  return data;
}

export async function createUser(body: UserCreateRequest): Promise<UserDetail> {
  const { data } = await api.post<UserDetail>("/admin/users", body);
  return data;
}

export async function updateUser(
  id: number,
  body: UserUpdateRequest,
): Promise<UserDetail> {
  const { data } = await api.put<UserDetail>(`/admin/users/${id}`, body);
  return data;
}

export async function deleteUser(id: number): Promise<void> {
  await api.delete(`/admin/users/${id}`);
}

export interface BadgeIssued {
  code: string;
  issued_at: string;
}

/** Выдать пропуск с QR. Код приходит ОДИН раз — в базе только хэш. */
export async function issueBadge(id: number): Promise<BadgeIssued> {
  const { data } = await api.post<BadgeIssued>(`/admin/users/${id}/badge`);
  return data;
}

export async function revokeBadge(id: number): Promise<void> {
  await api.delete(`/admin/users/${id}/badge`);
}
